import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment-timezone'
import { Backdrop, Box, Button, ClickAwayListener, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, MenuItem, Paper, TextField, Typography } from '@material-ui/core'
import { DisplayMessage, Loader } from '../../Components'
import _ from 'lodash'
import { connect, useSelector } from 'react-redux'
import { TableOutline, Cards, Toggle } from '../../elements'
import { eventService } from '../../Services/EventService'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import {
  systemsTableHeadings,
  eventsTableHeadings,
  ONGOINGANDUPCOMING,
  HISTORY,
  SYSTEMSENROLLED,
  SYSTEMSUNENROLLED,
  getEventToggleOptions,
  getSystemToggleOptions,
  EVENT_START_DATE_TIME,
  EVENT_END_DATE_TIME,
  DEFAULT_EVENT_PAGE_SIZE,
  DEFAULT_EVENT_PAGE_NO,
  DEFAULT_SYSTEM_PAGE_SIZE,
  DEFAULT_SYSTEM_PAGE_NO,
  DEFAULT_EVENT_LIST,
  DEFAULT_SYSTEM_LIST,
  DEFAULT_SYSTEM_SORT_BY,
  DEFAULT_EVENT_TIMELINE,
  EVENT_TIMELINE_BACKWARD,
  EVENT_TIMELINE_FORWARD,
  SYSTEM_UNENROLLED,
  SYSTEM_ENROLLED,
  EVENT_TYPE,
  ENROLLED,
  UNENROLLED,
  EVENT_SUBTYPE
} from './constants'
import { programViewStyles } from './style'
import BatteryChargeGraph from './BatteryChargeGraph'
import PowerGraph from './PowerGraph'
import { timeZoneAbbrs } from '../../utils/momentTimezones'
import { programService } from '../../Services'
import * as messageTypes from '../../utils/messageTypes'
import calendar from '../../Assets/Images/calendar.svg'
import { DateRange, DateRangePicker, Calendar } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { defaultSubType } from '../../layouts/eventDetails/constant'
import { accountService } from '../../Services/AccountService/AccountService'
import deleteIcon from '../../Assets/Images/delete.svg'
import { Update as UpdateIcon } from '@material-ui/icons'
import { registeredSitesTableHeadings } from './constants'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

const dropDownOptions = [{
  value: '1',
  label: 'Last 24 Hours'
}, {
  value: '3',
  label: 'Last 3 Days'
}, {
  value: '7',
  label: 'Last 7 Days'
}]

const ProgramView = (props) => {
  const classes = programViewStyles()
  const history = useHistory()
  const { programName, currentUser, programDetail } = props
  const programId = props.match?.params?.programs_id
  const [eventToggleValue, setEventToggleValue] = useState(ONGOINGANDUPCOMING)
  const [systemToggleValue, setSystemToggleValue] = useState(SYSTEMSENROLLED)
  const [loading, setLoading] = useState(false)
  const [accountId, setAccountId] = useState(currentUser.account_id)

  const [eventTotal, setEventTotal] = useState(0)
  const [totalEventCount, setTotalEventCount] = useState(0)
  const [eventPageNo, setEventPageNo] = useState(DEFAULT_EVENT_PAGE_NO)
  const [eventPageSize, setEventPageSize] = useState(DEFAULT_EVENT_PAGE_SIZE)
  const [eventSortBy, setEventSortBy] = useState(EVENT_START_DATE_TIME)
  const [eventTime, setEventTime] = useState(DEFAULT_EVENT_TIMELINE)
  const [eventSortAscendingOrder, setEventSortAscendingOrder] = useState(true)
  const [eventsList, setEventsList] = useState(DEFAULT_EVENT_LIST)
  const eventPageNoAPI = eventPageNo > 0 ? eventPageNo - 1 : 0

  const [systemTotal, setSystemTotalCount] = useState(0)
  const [systemPageNo, setSystemPageNo] = useState(DEFAULT_SYSTEM_PAGE_NO)
  const [systemPageSize, setSystemPageSize] = useState(DEFAULT_SYSTEM_PAGE_SIZE)
  const [systemSortBy, setSystemSortBy] = useState(DEFAULT_SYSTEM_SORT_BY)
  const [systemsList, setSystemsList] = useState(DEFAULT_SYSTEM_LIST)
  const [systemActive, setSystemActive] = useState(SYSTEM_ENROLLED)
  const [systemStatus, setSystemStatus] = useState(ENROLLED)
  const [eventLoading, setEventLoading] = useState(false)
  const [systemLoading, setSystemLoading] = useState(false)
  const [totalEnergy, setTotalEnergy] = useState()
  const [totalPower, setTotalPower] = useState()
  const [selectedValue, setSelectedValue] = useState('1')
  const [graphData, setGraphData] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [calendarOpen, setCalendarOpen] = useState(false)
  const { timeZone } = useSelector(state => state.auth)
  const [focusedRange, setFocusedRange] = useState([0, 0])
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleString('en-US', { timeZone: timeZone })),
    endDate: new Date(new Date().toLocaleString('en-US', { timeZone: timeZone })),
    key: 'selection',
  })
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleString('en-US', { timeZone: timeZone })),
    endDate: new Date(new Date().toLocaleString('en-US', { timeZone: timeZone })),
    key: 'selection',
  })
  const [eventsData, setEventsData] = useState([])
  const [crossHairValues, setCrossHairValues] = useState([])
  const [energyData, setEnergyData] = useState([])
  const [powerData, setPowerData] = useState([])
  const [openSelector, setOpenSelector] = useState(false)
  const [showGraph, setShowGraph] = useState(false)
  const [registeredSites, setRegisteredSites] = useState([])
  const [registeredSitesLoading, setRegisteredSitesLoading] = useState(false)
  const [deletingSiteId, setDeletingSiteId] = useState(null)
  const [editingNmiMap, setEditingNmiMap] = useState({})
  const [updatingSiteId, setUpdatingSiteId] = useState(null)
  const [openPopUp, setOpenPopUp] = useState(false)
  const [siteToDelete, setSiteToDelete] = useState(null)
  const [registeredSitesPageNo, setRegisteredSitesPageNo] = useState(1)
  const [registeredSitesPageSize, setRegisteredSitesPageSize] = useState(10)
  const [registeredSitesTotalCount, setRegisteredSitesTotalCount] = useState(0)
  const [newSiteId, setNewSiteId] = useState('')
  const [addingSite, setAddingSite] = useState(false)

  let requestBody = {
    columns: [
      'SITE ID',
      'SYSTEM NAME',
      'BATTERY CAPACITY (kWh)',
      programDetail && programDetail.feature_flags && programDetail.feature_flags.committed_power_in_program ? 'COMMITTED POWER (kW)' : 'BATTERY POWER (kW)'
    ],
  }

  const programStartDate = programDetail && programDetail.program_start_date

  const handleSelect = (ranges) => {
    if ((dateRange.startDate.getTime() !== ranges.selection.startDate.getTime() && dateRange.endDate.getTime() !== ranges.selection.endDate.getTime()) || focusedRange[1] === 0) {
      setOpenSelector(true)
    } else {
      setOpenSelector(false)
    }
    setDateRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: 'selection',
    })
  }

  const handleNmiChange = (siteId, value) => {
    setEditingNmiMap(prev => ({
      ...prev,
      [siteId]: value
    }))
  }

  const handleSiteAddition = () => {
    const profile = programDetail && programDetail.feature_flags && programDetail.feature_flags.csip_profile || ''
    setAddingSite(true)
    programService.addNewSite(accountId, newSiteId, profile, programId)
      .then(() => {
        setOpen(true)
        setMessage('Site added successfully')
        setMessageType(messageTypes.SUCCESS)
        getRegisteredSites()
        setNewSiteId('')
        setAddingSite(false)
      })
      .catch((error) => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to add site'))
        setMessageType(messageTypes.ERROR)
        setAddingSite(false)
        setNewSiteId('')
      })
  }

  const handleUpdateNmi = (siteId, currentNmi) => {
    const newNmi = editingNmiMap[siteId]
    if (!newNmi || newNmi === currentNmi) {
      setOpen(true)
      setMessage('Please enter a different NMI value')
      setMessageType(messageTypes.ERROR)
      return
    }

    setUpdatingSiteId(siteId)
    programService.updateSiteNmi(accountId, siteId, newNmi)
      .then(() => {
        setOpen(true)
        setMessage('NMI updated successfully')
        setMessageType(messageTypes.SUCCESS)
        setUpdatingSiteId(null)
        getRegisteredSites()
      })
      .catch((err) => {
        setOpen(true)
        setMessage(_.get(err, 'data.error.displayMessage', 'Failed to update NMI'))
        setMessageType(messageTypes.ERROR)
        setUpdatingSiteId(null)
      })
  }

  const handleUnregisterSite = (siteId) => {
    setDeletingSiteId(siteId)
    programService.unregisterSite(accountId, siteId)
      .then(() => {
        setOpen(true)
        setMessage('Site unregistered successfully')
        setMessageType(messageTypes.SUCCESS)
        setEditingNmiMap(prev => {
          const newMap = { ...prev }
          delete newMap[siteId]
          return newMap
        })
        getRegisteredSites()
        setDeletingSiteId(null)
      })
      .catch((err) => {
        setOpen(true)
        setMessage(_.get(err, 'data.error.displayMessage', 'Failed to unregister site'))
        setMessageType(messageTypes.ERROR)
        setDeletingSiteId(null)
      })
  }

  const getRegisteredSites = (pageNo = registeredSitesPageNo, pageSize = registeredSitesPageSize) => {
    setRegisteredSitesLoading(true)
    const gsProgramId = programId || ''
    const profile = programDetail && programDetail.feature_flags && programDetail.feature_flags.csip_profile || ''
    
    programService.getRegisteredSites(accountId, profile, gsProgramId, pageNo, pageSize)
      .then((response) => {
        setRegisteredSites(_.get(response, 'siteList', []))
        setRegisteredSitesTotalCount(_.get(response, 'total_count', 0))
        setRegisteredSitesLoading(false)
      })
      .catch((err) => {
        setRegisteredSites([])
        setRegisteredSitesTotalCount(0)
        setRegisteredSitesLoading(false)
        setOpen(true)
        setMessage(_.get(err, 'data.error.displayMessage', 'Failed to fetch registered sites'))
        setMessageType(messageTypes.ERROR)
      })
  }

  useEffect(() => {
    if (programId && accountId && !_.isEmpty(programDetail) && programDetail.id === programId) {
      setLoading(true)
      getSystems(systemSortBy, systemPageNo, systemPageSize, systemActive, systemStatus)
      getEvents(eventTime, eventSortBy, eventSortAscendingOrder, eventPageNoAPI, eventPageSize)
      if((props.isSuperAdmin || props.isViewOnly) && programDetail && programDetail.feature_flags && programDetail.feature_flags.csip_enabled) {
        getRegisteredSites()
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId, programDetail, accountId])

  const getSystems = (systemSortBy, systemPageNo, systemPageSize, systemActive, systemStatus) => {
    const systemPayload = {
      accountId,
      programId,
      requestBody,
      systemSortBy,
      systemPageNoAPI: systemPageNo > 0 ? systemPageNo - 1 : 0,
      systemPageSize,
      systemActive,
      systemStatus
    }
    setSystemLoading(true)
    systemsService
      .getAllSystemsWithFilter(systemPayload)
      .then((response) => {
        const { systems_info, total_count, total_energy_capacity, total_power_capacity } = response
        setSystemsList(systems_info || [])
        setSystemTotalCount(total_count || 0)
        setTotalEnergy(total_energy_capacity)
        setTotalPower(total_power_capacity)
        setLoading(false)
        setSystemLoading(false)
      })
      .catch((err) => {
        setSystemsList(DEFAULT_SYSTEM_LIST)
        setLoading(false)
        setSystemLoading(false)
      })
  }

  const getEvents = (eventTime, eventSortBy, eventSortAscendingOrder, eventPageNoAPI, eventPageSize) => {
    const eventPayload = {
      programId,
      accountId,
      eventTime,
      eventSortBy,
      eventSortAscendingOrder,
      eventPageNoAPI: eventPageNoAPI ? eventPageNoAPI - 1 : eventPageNoAPI,
      eventPageSize,
    }
    setLoading(true)
    setEventLoading(true)
    eventService
      .getAllEventsWithFilter(eventPayload)
      .then((response) => {
        setEventsList(_.get(response, 'vpp_event_list', []))
        setEventTotal(_.get(response, 'total_count', 0))
        setTotalEventCount(_.get(response, 'total_events_count', 0))
        setLoading(false)
        setEventLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        setEventsList(DEFAULT_EVENT_LIST)
        setEventLoading(false)
      })
  }

  const handleChangeRowsPerPageEvent = (value) => {
    setEventPageSize(value)
    setEventPageNo(1)
    getEvents(eventTime, eventSortBy, eventSortAscendingOrder, 1, value)
  }

  const handleChangePageRegisteredSites = (value) => {
    setRegisteredSitesPageNo(value)
    getRegisteredSites(value, registeredSitesPageSize)
  }

  const handleChangeRowsPerPageRegisteredSites = (value) => {
    setRegisteredSitesPageSize(value)
    setRegisteredSitesPageNo(1)
    getRegisteredSites(1, value)
  }

  const getEventData = () => {
    const eventDetails = []

    eventsList.forEach((obj) => {
      const startTime = moment(_.get(obj, 'start_date_time', ''))
      const endTime = moment(_.get(obj, 'end_date_time', ''))
      const duration = moment.duration(endTime.diff(startTime))
      let tableObj = [
        {
          id: 'eventName',
          value: _.get(obj, 'name', ''),
          statusValue: _.get(obj, 'status', 'new'),
          programId: _.get(obj, 'id', ''),
          eventId: _.get(obj, 'event_id', ''),
          handleClick: (selected) => {
            const { eventId } = selected
            props.history.push({
              pathname: `/programs/${programId}/events/${eventId}`
            })
          },
        },
        {
          id: 'eventType',
          value: obj.type ? EVENT_TYPE[obj.type] : 'Discharge Event',
        },
        {
          id: 'eventSubType',
          value: obj.subtype ? EVENT_SUBTYPE[obj.subtype] : defaultSubType[obj.type] || <Box textAlign="center">{'-'}</Box>,
        },
        {
          id: 'eventStartTime',
          value: obj.start_date_time ? moment.tz(obj.start_date_time, props.timeZone).format('MMMM DD, YYYY hh:mm A zz') : '--',
        },
        {
          id: 'eventDuration',
          value: _.get(obj, 'start_date_time', '') && _.get(obj, 'end_date_time', '') ? `${Math.floor(duration.asHours())} hour(s) ${moment.utc(duration.asMilliseconds()).format("mm")} minute(s)` : '-'
        },
      ]
      eventDetails.push(tableObj)
    })
    return eventDetails
  }

  const handleEventPageChange = (value) => {
    setEventPageNo(value)
    getEvents(eventTime, eventSortBy, eventSortAscendingOrder, value, eventPageSize)
  }

  const handleEventToggleChange = (value) => {
    setEventToggleValue(value)
    if (value === ONGOINGANDUPCOMING) {
      setEventSortAscendingOrder(true)
      setEventTime(EVENT_TIMELINE_FORWARD)
      setEventSortBy(EVENT_START_DATE_TIME)
      getEvents(EVENT_TIMELINE_FORWARD, EVENT_START_DATE_TIME, true, 1, eventPageSize)
    } else if (value === HISTORY) {
      setEventSortAscendingOrder(false)
      setEventTime(EVENT_TIMELINE_BACKWARD)
      setEventSortBy(EVENT_END_DATE_TIME)
      getEvents(EVENT_TIMELINE_BACKWARD, EVENT_END_DATE_TIME, false, 1, eventPageSize)
    }
    setEventPageNo(1)
  }

  const handlePopUp = (siteId) => {
    setSiteToDelete(siteId)
    setOpenPopUp(true)
  }

  const handleClose = () => {
    setOpenPopUp(false)
    setSiteToDelete(null)
  }

  const handleConfirmDelete = () => {
    setOpenPopUp(false)
    handleUnregisterSite(siteToDelete)
    setSiteToDelete(null)
  }

  const getRegisteredSitesData = () => {
    const siteDetails = []
    registeredSites.forEach((site, index) => {
      const siteId = _.get(site, 'siteId', '')
      const currentNmi = _.get(site, 'nmi', '')
      const isUpdating = updatingSiteId === siteId
      
      let tableObj = [
        {
          id: 'srNo',
          value: index + 1
        },
        {
          id: 'siteId',
          value: siteId || '-'
        },
        {
          id: 'name',
          value: _.get(site, 'name', '-')
        },
        {
          id: 'lfdi',
          value: _.get(site, 'lfdiString', '-')
        },
        {
          id: 'nmi',
          value: (
            <Box display="flex" alignItems="center" gap={1}>
              <TextField
                size="small"
                variant="outlined"
                value={editingNmiMap[siteId] !== undefined ? editingNmiMap[siteId] : currentNmi}
                onChange={(e) => handleNmiChange(siteId, e.target.value)}
                disabled={isUpdating}
                style={{ minWidth: '120px' }}
                inputProps={{ style: { padding: '6px 8px' } }}
              />
              {props.isSuperAdmin &&<UpdateIcon
                style={{
                  cursor: isUpdating ? 'not-allowed' : 'pointer',
                  opacity: isUpdating ? 0.5 : 1,
                  color: '#026AE3',
                  fontSize: '20px',
                  marginLeft: '10px'
                }}
                onClick={() => !isUpdating && handleUpdateNmi(siteId, currentNmi)}
              />}
            </Box>
          )
        },
        {
          id: 'status',
          value: _.get(site, 'status', '-')
        },
        ...(props.isSuperAdmin ? [{
          id: 'actions',
          value: (
            <img 
              src={deleteIcon} 
              alt="Delete" 
              style={{ 
                cursor: deletingSiteId === siteId ? 'not-allowed' : 'pointer',
                width: '20px',
                height: '20px',
                opacity: deletingSiteId === siteId ? 0.5 : 1
              }}
              onClick={() => deletingSiteId !== siteId && handlePopUp(siteId)}
            />
          )
        }] : [])
      ]
      siteDetails.push(tableObj)
    })
    return siteDetails
  }

  const renderRegisteredSites = () => {
    const tableData = getRegisteredSitesData()
    return (
      <Box>
        <Box className={classes.headerWrapper}>
          <Box>
            Registered Sites Management
          </Box>
        </Box>
        <br />
        <TableOutline
          tableHeadings={props.isSuperAdmin ? registeredSitesTableHeadings : registeredSitesTableHeadings.filter(h => h.id !== 'actions')}
          tableData={tableData}
          totalElement={registeredSitesTotalCount}
          page={registeredSitesPageNo}
          rowsPerPage={registeredSitesPageSize}
          handleChangePage={handleChangePageRegisteredSites}
          handleChangeRowsPerPage={handleChangeRowsPerPageRegisteredSites}
          pagination
          loading={registeredSitesLoading}
          isRegisteredSitesManagement={true}
          newSiteId={newSiteId}
          setNewSiteId={setNewSiteId} 
          handleSiteAddition={handleSiteAddition}
          isSuperAdmin={props.isSuperAdmin}
          addingSite={addingSite}
        />
      </Box>
    )
  }
  const renderEventContent = () => {
    const tableData = getEventData()
    return (
      <Box>
        <Box className={classes.headerWrapper}>
          <Box>
            Events -{' '}
            <span style={{ fontWeight: 'normal' }}>
              ( Total Events - {totalEventCount} )
            </span>
          </Box>
          <Box className={classes.rightBarView}>
            <Box
              className={classes.rightBarViewMargin}
              onClick={() => {
                history.push({
                  pathname: `/programs/${programId}/events`,
                  state: {
                    programId: programId,
                    programName: programName,
                    obj: props.programDetail || {},
                    vppCount: props.vppCount || 0,
                    programIsActive: props.isActive
                  },
                })
              }}
            >
              View All Events
            </Box>
          </Box>
        </Box>
        <Toggle
          list={getEventToggleOptions()}
          selected={eventToggleValue}
          onChange={handleEventToggleChange}
        />
        <br />
        <br />
        <TableOutline
          tableHeadings={eventsTableHeadings}
          tableData={tableData}
          totalElement={eventTotal}
          page={eventPageNo}
          rowsPerPage={eventPageSize}
          handleChangePage={handleEventPageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPageEvent}
          pagination
          loading={eventLoading}
        />
      </Box>
    )
  }

  const getSystemData = () => {
    const systemDetails = []
    systemsList.forEach((obj) => {
      let tableObj = [
        {
          id: 'siteId',
          value: obj ? obj[0] : '',
          enrollmentId: obj ? obj[0] : '',
          handleClick: (selected) => {
            const enrollment_id = _.get(selected, 'enrollmentId', '')
            const { id, value, enrollmentId } = selected
            const curSystem = {
              id,
              value,
              enrollmentId,
            }
            history.push({
              pathname: `/programs/${programId}/systems/${enrollmentId}`,
              state: {
                curSystem: curSystem,
                programId: programId,
                siteId: curSystem.enrollmentId
              },
            })
          },
        },
        {
          id: 'systemName',
          value: (obj && obj[1]) ? obj[1] : '',
        },
        {
          id: 'batteryCapacity',
          value: (obj && obj[2]) ? obj[2] : '',
          className: `${classes.textAlignCenter} ${classes.batteryCapacity}`
        },
        {
          id: 'batteryPower',
          value: (obj && obj[3]) ? obj[3] : '',
          className: `${classes.textAlignCenter} ${classes.batteryPower}`
        },
      ]
      systemDetails.push(tableObj)
    })

    return systemDetails
  }

  //to be updated
  const handleSystemToggleChange = (value) => {
    setSystemToggleValue(value)
    setSystemPageNo(1)
    setLoading(true)
    if (value === SYSTEMSENROLLED) {
      setSystemActive(SYSTEM_ENROLLED)
      setSystemStatus(ENROLLED)
      getSystems(systemSortBy, 1, systemPageSize, SYSTEM_ENROLLED, ENROLLED)
    } else if (value === SYSTEMSUNENROLLED) {
      setSystemActive(SYSTEM_UNENROLLED)
      setSystemStatus(UNENROLLED)
      getSystems(systemSortBy, 1, systemPageSize, SYSTEM_UNENROLLED, UNENROLLED)
    }
  }

  const handleSystemPageChange = (value) => {
    setSystemPageNo(value)
    getSystems(systemSortBy, value, systemPageSize, systemActive, systemStatus)
  }

  const handleChangeRowsPerPageSystem = (value) => {
    setSystemPageSize(value)
    setSystemPageNo(1)
    getSystems(systemSortBy, 1, value, systemActive, systemStatus)
  }

  const getGraphData = () => {
    let start_date = moment.tz(selectedDateRange.startDate.toLocaleString('en-US'), 'M/D/YYYY, HH:mm:ss', timeZone).startOf('day').utc().format('DD-MM-YYYY')
    let end_date = moment.tz(selectedDateRange.endDate.toLocaleString('en-US'), 'M/D/YYYY, HH:mm:ss', timeZone).endOf('day').utc().format('DD-MM-YYYY')
    const startDate = moment.tz(selectedDateRange.startDate.toLocaleString('en-US'), 'M/D/YYYY, HH:mm:ss', timeZone).startOf('day').format('YYYY-MM-DD HH:mm:ssZ')
    const endDate = moment.tz(selectedDateRange.endDate.toLocaleString('en-US'), 'M/D/YYYY, HH:mm:ss', timeZone).endOf('day').format('YYYY-MM-DD HH:mm:ssZ')
    programService.getBatteryChargeGraphData(currentUser.account_id, programId, start_date, end_date)
      .then(graphData => {
        setGraphData(graphData)
      })
      .catch(error => {
        setOpen(true)
        setGraphData({})
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
    eventService.getAllEventsCalendarEvents({ programId, accountId: currentUser.account_id, startDate, endDate })
      .then(eventsData => {
        setEventsData(eventsData.vpp_event_list)
      })
      .catch(error => {
        setOpen(true)
        setGraphData({})
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })

  }

  const getAccountDetails = (id) => {
    accountService.getAccountDetails({ account_id: id })
      .then(accountDetails => {
        setShowGraph(!accountDetails?.apiAccess)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getAllAccounts = (id) => {
    accountService.getAllAccounts(props.accountId)
      .then(accountDetails => {
        let account = accountDetails.find(account => account.id === id)
        setShowGraph(!account?.apiAccess)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const renderSystemContent = () => {
    const tableData = getSystemData()
    return (
      <Box>
        <Box className={classes.headerWrapper}>
          <Box>
            Systems -{' '}
            <span style={{ fontWeight: 'normal' }}>
              ( Total {systemToggleValue === SYSTEMSENROLLED ? 'Enrolled' : 'Unenrolled'} - {systemTotal || 0} )
            </span>
          </Box>
          <Box className={classes.rightBarView}>
            <Box
              className={classes.rightBarViewMargin}
              onClick={() => {
                history.push({
                  pathname: `/programs/${programId}/systems`
                })
              }}
            >
              View All Systems
            </Box>
          </Box>
        </Box>
        <Toggle
          list={getSystemToggleOptions()}
          selected={systemToggleValue}
          onChange={handleSystemToggleChange}
        />
        <br />
        <br />
        <TableOutline
          tableHeadings={systemsTableHeadings(_.get(programDetail, 'feature_flags.committed_power_in_program', false), classes)}
          tableData={tableData}
          totalElement={systemTotal}
          page={systemPageNo}
          rowsPerPage={systemPageSize}
          handleChangePage={handleSystemPageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPageSystem}
          pagination
          loading={systemLoading}
        />
      </Box>
    )
  }

  useEffect(() => {
    if (calendarOpen) {
      document.getElementsByClassName(`${classes.calendarWrapper}`)[0].scrollIntoView()
    }
  }, [calendarOpen])

  const renderGraphCard = () => (
    <>
      <Box my={2}>
        <Paper elevation={1}>
          <Box className={classes.graphHeaderWrapper}>
            <Box className={classes.graphHeading}>
              <Box mr={1}>
                <Typography className={classes.bold}>Available Energy and Power Graph</Typography>
              </Box>
              <Box>
                <Typography>{`(Total Energy - ${totalEnergy ? totalEnergy.toFixed(2) : '-'} kWh; Total Power - ${totalPower ? totalPower.toFixed(2) : '-'} kW)`}</Typography>
              </Box>
            </Box>
            <Box display="flex" marginLeft="auto">
              <TextField
                id="duration"
                fullWidth
                size="small"
                value={`${moment(dateRange.startDate).format('DD/MM/YYYY')} - ${moment(dateRange.endDate).format('DD/MM/YYYY')}`}
                style={{ minWidth: 210, maxWidth: 350 }}
                label="View Data for"
                InputProps={{
                  classes: { root: classes.input },
                  type: 'text',
                  endAdornment: <img src={calendar} />,
                  readOnly: true
                }}
                onClick={() => setCalendarOpen(openCalendar => !openCalendar)}
              />
              {calendarOpen &&
                <>
                  <Backdrop open={calendarOpen} onClick={() => setCalendarOpen(openCalendar => !openCalendar)} className={classes.backdrop} />
                  <ClickAwayListener onClickAway={() => setCalendarOpen(false)}>
                    <Box className={classes.dateWrapper}>
                      <Box className={classes.root}>
                        <Box className={classes.calendarWrapper}>
                          <DateRange
                            ranges={[dateRange]}
                            months={2}
                            focusedRange={focusedRange}
                            onRangeFocusChange={(range) => {
                              if (range[1] === 1) {
                                setOpenSelector(true)
                              } else {
                                setOpenSelector(false)
                              }
                              setFocusedRange(range)
                            }}
                            direction={window.innerWidth <= 900 ? '' : 'horizontal'}
                            minDate={programStartDate && new Date(moment.unix(programStartDate / 1000).tz(props.timeZone).format('YYYY-MM-DD'))}
                            maxDate={new Date(new Date().toLocaleString('en-US', { timeZone: timeZone }))}
                            dragSelectionEnabled={false}
                            color="#F37320"
                            rangeColors={["#F37320"]}
                            disabledDay={(date) => {
                              return openSelector && ((moment(date).diff(moment(dateRange.startDate), 'days') >= 7) || (moment(date).diff(moment(dateRange.startDate), 'days') <= -7))
                            }}
                            onChange={handleSelect}
                          />
                          <Box display="flex" justifyContent="flex-end">
                            <Button className={classes.button} onClick={() => {
                              setOpenSelector(false)
                              setFocusedRange([0, 0])
                              setDateRange({
                                startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleString('en-US', { timeZone: timeZone })),
                                endDate: new Date(new Date().toLocaleString('en-US', { timeZone: timeZone })),
                                key: 'selection',
                              })
                            }}>Reset</Button>
                            <Button className={classes.button} onClick={() => { setCalendarOpen(false); setSelectedDateRange(dateRange) }}>Done</Button>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </ClickAwayListener>
                </>
              }
            </Box>
          </Box>
          <BatteryChargeGraph totalEnergy={totalEnergy} selectedValue={selectedValue} graphData={graphData} eventsData={eventsData} selectedDateRange={selectedDateRange} crossHairValues={crossHairValues} setCrossHairValues={setCrossHairValues} powerData={powerData} setEnergyData={setEnergyData} />
          <PowerGraph totalPower={totalPower} selectedValue={selectedValue} graphData={graphData} eventsData={eventsData} selectedDateRange={selectedDateRange} crossHairValues={crossHairValues} setCrossHairValues={setCrossHairValues} energyData={energyData} setPowerData={setPowerData} />
        </Paper>
      </Box>
    </>
  )

  useEffect(() => {
    if (programId && showGraph)
      getGraphData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDateRange, programId, showGraph])

  useEffect(() => {
    if (programDetail.account_id) {
      if (props.isSuperAdmin || props.isViewOnly) {
        getAllAccounts(programDetail.account_id)
      } else {
        getAccountDetails(programDetail.account_id)
      }
    }
  }, [programDetail])

  return (
    <>
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} /> 
      <Dialog
        open={openPopUp}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm Site Unregistration</DialogTitle>
        <DialogContent>
            Are you sure you want to unregister this site?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className={classes.button}>
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} className={classes.button} >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box className={classes.programViewStyle}>
        <Grid container>
          <Grid item sm={12} md={6}>
            <Cards className={classes.cardWrapper} children={renderSystemContent()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <Cards className={classes.cardWrapper} children={renderEventContent()} />
          </Grid>
          {showGraph &&
            <Grid item xs={12}>
              <Cards className={classes.graphCardWrapper} children={renderGraphCard()} />
            </Grid>
          }
          {(props.isSuperAdmin || props.isViewOnly) && programDetail && programDetail.feature_flags && programDetail.feature_flags.csip_enabled && 
            <Grid item xs={12}>
              <Cards className={classes.cardWrapper} children={renderRegisteredSites()} />
            </Grid>
          }
        </Grid>
        <Loader loading={loading} />
      </Box>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.auth.currentUser,
    timeZone: state.auth.timeZone,
    isSuperAdmin: state.auth.isSuperAdmin,
    isAdmin: state.auth.isAdmin,
    isViewOnly: state.auth.isViewOnly
  }
}

export default connect(mapStateToProps, null)(ProgramView)